import { render } from "./PublicityGalleryView.vue?vue&type=template&id=f7a6c2e0&scoped=true"
import script from "./PublicityGalleryView.vue?vue&type=script&lang=js"
export * from "./PublicityGalleryView.vue?vue&type=script&lang=js"

import "./PublicityGalleryView.vue?vue&type=style&index=0&id=f7a6c2e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7a6c2e0"]])

export default __exports__